(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skopos-reward-status"] && !Shopify.designMode) return;
  try {
    if(!window.SkoposReward){
 const code='FOCUS20';let revision=0;let applying=null;
 const root=()=>window.Shopify?.routes?.root||'/';
 function stateFor(cart){
  const saved=(cart.discount_codes||[]).find(item=>String(item.code).toUpperCase()===code);
  const allocations=(cart.cart_level_discount_applications||[]).concat((cart.items||[]).flatMap(item=>(item.line_level_discount_allocations||[]).map(allocation=>({...allocation.discount_application,total_allocated_amount:allocation.amount}))));
  const reward=allocations.some(item=>String(item.title).toUpperCase()===code&&Number(item.total_allocated_amount)>0);
  if(reward&&saved?.applicable!==false)return {kind:'active',combined:allocations.some(item=>item.title==='Buy 2, get 1 FREE'&&Number(item.total_allocated_amount)>0),cart};
  if(!saved)return {kind:'none',cart};
  if(!cart.item_count)return {kind:'ready',cart};
  return {kind:'unavailable',cart};
 }
 function render(node){
  const {kind,combined}=window.SkoposReward.state;const data=node.dataset;node.hidden=kind==='none';node.dataset.state=kind;if(node.hidden)return;
  const isCart=data.context==='cart';
  node.querySelector('[data-reward-status-title]').textContent=kind==='active'?(combined?data.combined:isCart?data.applied:data.active):kind==='ready'?data.active:data[kind];
  node.querySelector('[data-reward-status-body]').textContent=kind==='active'?(combined?data.combinedBody:isCart?'':data.activeBody):data[kind+'Body'];
  node.querySelector('[data-reward-status-retry]').hidden=!['unavailable','failed'].includes(kind);
 }
 function update(cart){revision++;const state=stateFor(cart);window.SkoposReward.state=state;document.querySelectorAll('skopos-reward-status').forEach(render);document.dispatchEvent(new CustomEvent('skopos:reward-state',{detail:state}));return state;}
 async function request(path,payload){
  const options={credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(12000)};
  if(payload){options.method='POST';options.headers['Content-Type']='application/json';options.body=JSON.stringify(payload);}
  const response=await fetch(root()+path,options);if(!response.ok)throw new Error('Reward request failed');return response.json();
 }
 async function refresh(){const version=revision;const cart=await request('cart.js');if(version===revision)update(cart);return window.SkoposReward.state;}
 async function activate(){
  revision++;
  let cart=window.SkoposIncludedSleeve?await window.SkoposIncludedSleeve.refresh():await request('cart.js');
  const current=stateFor(cart);
  if(!['active','ready'].includes(current.kind)){
   const codes=Array.from(new Set((cart.discount_codes||[]).map(item=>String(item.code)).concat(code)));
   const payload={discount:codes.join(',')};
   cart=window.SkoposIncludedSleeve?await window.SkoposIncludedSleeve.update('cart/update.js',payload):await request('cart/update.js',payload);
  }
  const state=update(cart);
  document.dispatchEvent(new CustomEvent('skopos:reward-applied',{detail:cart}));
  document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
  return state;
 }
 window.SkoposReward={state:{kind:'none'},stateFor,render,update,refresh,apply(){if(!applying)applying=activate().finally(()=>{applying=null});return applying;}};
 addEventListener('pageshow',()=>refresh().catch(()=>{}));
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')refresh().catch(()=>{});});
 refresh().catch(()=>{});
}
if(!customElements.get('skopos-reward-status')){
 class SkoposRewardStatus extends HTMLElement{
  connectedCallback(){
   window.SkoposReward.render(this);if(this.initialized)return;this.initialized=true;
   this.querySelector('[data-reward-status-retry]').addEventListener('click',async()=>{const button=this.querySelector('button');button.disabled=true;try{await window.SkoposReward.apply();}catch{this.querySelector('[data-reward-status-title]').textContent=this.dataset.failed;this.querySelector('[data-reward-status-body]').textContent=this.dataset.failedBody;this.dataset.state='failed';}finally{button.disabled=false}});
  }
 }
 customElements.define('skopos-reward-status',SkoposRewardStatus);
}
  } catch(e) { console.error(e); }
})();

})();
